import styled from 'styled-components';

import {
  colorPrimary,
  colorWhite,
  colorBlack900,
  colorPrimaryLighten85,
  colorPrimaryLighten95,
} from 'styles';

export const Wrapper = styled.option`
  cursor: pointer;
  background-color: ${colorWhite};
  color: ${colorBlack900};
  display: block;
  font-size: 14px;
  font-weight: 400;
  padding: 16px 36px 16px 16px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  text-align: start;
  outline: 0;

  ${props => {
    if (props['data-checked']) {
      return `
        background-color: ${colorPrimaryLighten85};
        color: ${colorBlack900};

        &::after {
          border-width: 0 2px 2px 0;
          border-color: ${colorPrimary};
          border-style: solid;
          content: '';
          height: 11px;
          margin-top: -8px;
          min-width: 7px;
          transform: rotate(45deg);
          width: 7px;
          position: absolute;
          right: 16px;
          top: 50%;
        }
      `;
    }

    return '';
  }}

  &:hover,
  &.focus-visible {
    background-color: ${colorPrimaryLighten95};
    color: ${colorBlack900};
  }

  &:active {
    outline: 0;
  }
`;

export const Input = styled.input`
  display: none;
`;
